import type { Supplier } from '@/services/supplierService';
import type { ComboboxOption } from '@/components/ui/combobox';

/**
 * Suppliers can have an empty AdjustedName (and Name) and many share the same name, so the
 * display name falls back to name/code and the option is keyed by the supplier id.
 */
export const supplierDisplayName = (s: Supplier) => s.adjustedName || s.name || s.code;

export const toSupplierOptions = (suppliers: Supplier[]): ComboboxOption[] =>
  suppliers.map((s) => ({
    key: String(s.id),
    value: supplierDisplayName(s),
    label: supplierDisplayName(s),
    sublabel: s.code + (s.businessUnitName ? ` - ${s.businessUnitName}` : ''),
  }));
